module.exports = __webpack_public_path__ + "static/media/caret-down.28de92ef.svg";